export const TITLE: string = "KoçAilem Alışveriş";
export const LOCAL_STORAGE = {
    ACCESS_TOKEN: "ACCESS_TOKEN",
    USER_ID: "USER_ID",
    USER_FULLNAME: "USER_FULLNAME",
    PERMISSIONS: "PERMISSIONS",
    USER_EMAIL: "USER_EMAIL",
    EXPIRED_TIME: "EXPIRED_TIME",
    REFRESH_TOKEN: "REFRESH_TOKEN",
    POSITION: "POSITION",
    AUTO_LOGOUT_EXPIRED: "AUTO_LOGOUT_EXPIRED",
    LAST_ACTIVITY_TIME: "LAST_ACTIVITY_TIME",
};
export const MESSAGE_TYPE = {
    SUCCESS: "success",
    ERROR: "error",
    INFO: "info",
    WARNING: "warning",
};

export const COMM_TYPES = {
    EMAIL: 'email',
    PHONE: 'phone'
}

export const KS_MEMBER_TYPES = {
    CALISAN: 1,
    EMEKLI: 2,
    OGRENCI: 3,
    BAYI: 4,
    CALISAN_YAKINI: 5,
    DIGER: 6,
    EMEKLI_YAKINI: 7,
    DIGER_YAKINI: 8,
    SERVIS_BAYI_CALISAN: 9,
    KU_MEZUN: 10
  }

export const RELATIVE_TYPES = {
    Anne: 1,
    Baba: 2,
    Es: 3,
    Cocuk: 4,
    Kardes: 5,
}

export const SELECT_EMPTY: string = "EMPTY";
